package com.essntl.core.supabase

import org.koin.dsl.module

val supabaseModule get() =
    module {
        single { createEssntlSupabaseClient() }
    }
